module.exports = __webpack_public_path__ + "static/media/collection-bird-06.ef433aaa.png";